import { setCompanyTimeZone } from 'src/components/common/helpers'
import { BreakResponse, IBreakResponse } from '@loadedhub/core-api-sdk'

export { BreakResponse, type IBreakResponse } from '@loadedhub/core-api-sdk'

// Functions to apply transformations to BreakDetail object
export const transformBreakDetailOnGet = (
  breakDetail: IBreakResponse
): IBreakResponse => {
  return {
    ...breakDetail,
    breakStart: setCompanyTimeZone(breakDetail.breakStart),
    breakEnd: breakDetail.breakEnd
      ? setCompanyTimeZone(breakDetail.breakEnd)
      : undefined,
  }
}

export const transformBreakDetailOnSave = (
  breakDetail: IBreakResponse
): BreakResponse => {
  return {
    ...breakDetail,
    breakStart: breakDetail.breakStart.utc(),
    breakEnd: breakDetail.breakEnd ? breakDetail.breakEnd.utc() : null,
  } as BreakResponse
}
